import React from 'react';
import { Redirect } from '@reach/router';

const IndexPage = () => <Redirect to={'/'} noThrow={true} />;

export default IndexPage;
